<script>
  import Gradient from "./Components/Gradient.svelte"
  import SolidColor from "./Components/solidColor.svelte"
  import Pattern from "./Components/pattern.svelte"
  export let headerBackground
  export let position = "bottom"
  export let disableGradient = false
  export let disablePattern = true
  export let colorCount
  export let column = 5

  export let BtnName = "Add Color"
  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showPalette = false
  /**
   * @type {String} the default or active font family in the dropdown area
   */
  /**
   * @type {HTMLElement} binded the overall dropdown parent element
   */
  let palette

  let showContainer = false

  export let customColors = []

  /**
   * @typedef {Object} ActiveComponent indicates the active component of the color palette
   * @type {Object}
   * indicates the active component of the color palette
   *
   * @property {String} type name of the active component
   * @property {HTMLElement} component svelte component to be shown
   * @property {Boolean} active whether to show the active component
   */

  /**
   *@type {Array<ActiveComponent>}
   */
  let paletteItems = [
    {
      type: "Solid",
      component: SolidColor,
      active: true,
    },
    {
      type: "Gradient",
      component: Gradient,
      active: false,
    },
    // {
    //   type: "Pattern",
    //   component: Pattern,
    //   active: false,
    // },
  ]

  /**
   * @description function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (palette.contains(e.target) == false && !showContainer) showPalette = false
  }

  /**
   * @description function to change the active component
   * @param {type} type name of the active palette
   */
  const changeActiveComponent = (type) => {
    paletteItems = paletteItems.map((item) => {
      item.active = item.type == type
      return item
    })
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div id="palette" class="relative w-full" bind:this={palette}>
  <button
    type="button"
    on:click={() => {
      showPalette = !showPalette
    }}
    class="flex h-9 w-full min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-extraBlue-500 px-2 text-sm font-medium text-white hover:bg-extraBlue-600 focus:outline-none active:bg-extraBlue-600 lg:px-4"
  >
    <span>
      <i class="fa-solid fa-sliders" />
    </span>
    <span class="select-none">&nbsp;&nbsp;{BtnName}&nbsp;</span>
  </button>
  {#if showPalette}
    <div style="width: {column * 52.8 + 40}px" class="absolute z-[9999] {position} max-h-fit overflow-auto rounded-md border border-[#a0a1a580] bg-white p-3 text-base shadow-2xl ring-opacity-5 focus:outline-none dark:bg-darkgray sm:text-sm">
      <div class="flex w-full gap-3">
        {#each paletteItems as item}
          <button disabled={(item.type == "Pattern" && disablePattern) || (item.type == "Gradient" && disableGradient)} on:click={() => changeActiveComponent(item.type)} type="button" class="rounded-md {item.active ? 'rounded-md bg-[#f7f7f7] dark:bg-bodyblack dark:text-slate-200' : 'bg-transparent'} w-full px-2 py-1 text-sm font-bold text-[#5A5A5C] disabled:cursor-not-allowed">
            {item.type}
          </button>
        {/each}
      </div>
      <div class="pt-3">
        {#each paletteItems as item}
          {#if item.active}
            <svelte:component this={item.component} bind:customColors bind:showContainer bind:headerBackground {colorCount} {column} />
          {/if}
        {/each}
      </div>
    </div>
  {/if}
</div>

<style>
  .top {
    bottom: 40px;
    left: 0px;
  }
  .bottom {
    margin-top: 4px;
  }
</style>
